import { Divider, Chip, Box, Typography } from "@mui/material";

const DivChip = ({ text }) => {
  return (
    <>
      <Box component="div" sx={{ m: 2, p: 2 }}>
        <Divider>
          <Chip
            size="medium"
            sx={{ p: 3 }}
            label={<Typography variant="h6"> {text} </Typography>}
          />
        </Divider>
      </Box>
    </>
  );
};
export default DivChip;
